import { BaseRouteService } from 'core/services';

class FulfillmentOrderItemRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-order-items/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create() {
		return super.create(this.base);
	}

	update(resource) {
		return super.update(this.base + '{id}', resource);
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default FulfillmentOrderItemRouteService;
